import _ from 'lodash';
var fitsMaxWidth = function fitsMaxWidth(width, maxWidth) {
  return _.isNil(maxWidth) ? true : width <= maxWidth;
};
var fitsMinWidth = function fitsMinWidth(width, minWidth) {
  return _.isNil(minWidth) ? true : width >= minWidth;
};
export var isVisible = function isVisible(width, _ref) {
  var maxWidth = _ref.maxWidth,
    minWidth = _ref.minWidth;
  return fitsMinWidth(width, minWidth) && fitsMaxWidth(width, maxWidth);
};
export default isVisible;